import { connectRouter } from "connected-react-router";
import { History } from "history";
import { Reducer, combineReducers } from "redux";
import { FormStateMap, reducer as formReducer } from "redux-form";

import { PageAlertState } from "../../types/appTypes/general";
import { Authnz, MiniMessageBox, PageAlert } from "../components";
import claimSearch, { ClaimSearchState } from "./appReducers/claims/search";
import drug, { DrugState } from "./appReducers/drug/drug";
import groupGet, { GroupGetState } from "./appReducers/groups/get";
import memberInformation, { MemberInformationState } from "./appReducers/members/information";
import memberSearch, { MemberSearchState } from "./appReducers/members/search";
import migrate, { MigrateState } from "./appReducers/migrate/migrate";
import pharmacyGet, { PharmacyGetState } from "./appReducers/pharmacy/get";
import pharmacySearch, { PharmacySearchState } from "./appReducers/pharmacy/search";
import planAccount, { GetPlanAccountState } from "./appReducers/planAccount/get";
import planBenefitSearch, { PlanBenefitSearchState } from "./appReducers/planBenefits/search";
import planGet, { PlanGetState } from "./appReducers/plans/get";
import planSearch, { PlanSearchState } from "./appReducers/plans/search";
import pricingLevelsGet, { PricingLevelGetState } from "./appReducers/pricingLevels/get";
import pricingLevelsList, { PricingLevelsListState } from "./appReducers/pricingLevels/list";
import productListGet, { ProductListGetState } from "./appReducers/productLists/get";
import batchManualClaim, { BatchManualClaimState } from "./appReducers/transmissions/batchManual/get";
import batchManualClaimList, { BatchManualClaimListState } from "./appReducers/transmissions/batchManual/list";
import batchTestClaim, { BatchTestClaimState } from "./appReducers/transmissions/batchTest/get";
import batchTestClaimList, { BatchTestClaimListState } from "./appReducers/transmissions/batchTest/list";
import transmissionManual, { TransmissionManualState } from "./appReducers/transmissions/manualTransmission";
import transmissionTest, { TransmissionTestState } from "./appReducers/transmissions/testTransmission";
import userPermissionsGet, { UserPermissionsGetState } from "./appReducers/userPermissions/get";

interface AuthnzState {
  forgotPassword: {
    formSubmitSuccess: boolean;
  };
}

interface MiniMessageBoxState {
  show: boolean;
  type: string;
  message: string;
}

export interface RootState {
  form: FormStateMap;
  authnz: AuthnzState;
  pageAlert: PageAlertState;
  miniMessageBox: MiniMessageBoxState;
  claimSearch: ClaimSearchState;
  memberInformation: MemberInformationState;
  memberSearch: MemberSearchState;
  planBenefitSearch: PlanBenefitSearchState;
  planSearch: PlanSearchState;
  groupGet: GroupGetState;
  pharmacyGet: PharmacyGetState;
  planGet: PlanGetState;
  planAccount: GetPlanAccountState;
  pharmacySearch: PharmacySearchState;
  pricingLevelsList: PricingLevelsListState;
  pricingLevelsGet: PricingLevelGetState;
  batchTestClaim: BatchTestClaimState;
  batchTestClaimList: BatchTestClaimListState;
  batchManualClaim: BatchManualClaimState;
  batchManualClaimList: BatchManualClaimListState;
  transmissionTest: TransmissionTestState;
  transmissionManual: TransmissionManualState;
  userPermissionsGet: UserPermissionsGetState;
  drug: DrugState;
  productListGet: ProductListGetState;
  migrate: MigrateState;
}

export default (history: History): Reducer =>
  combineReducers({
    form: formReducer,
    authnz: Authnz.authnzReducer,
    router: connectRouter(history),
    miniMessageBox: MiniMessageBox.miniMessageBoxReducer,
    pageAlert: PageAlert.pageAlertReducer,
    claimSearch,
    memberInformation,
    memberSearch,
    planBenefitSearch,
    planSearch,
    groupGet,
    planGet,
    planAccount,
    pharmacySearch,
    pricingLevelsList,
    pricingLevelsGet,
    pharmacyGet,
    batchTestClaim,
    batchTestClaimList,
    batchManualClaim,
    batchManualClaimList,
    transmissionTest,
    transmissionManual,
    userPermissionsGet,
    drug,
    productListGet,
    migrate,
  });
